(function ($) {
    /* Main functions */

    var APP = {

        IS_TOUCH_DEVICE: (
            'ontouchstart' in window ||
            navigator.maxTouchPoints > 0 ||
            window.matchMedia('(pointer: coarse)').matches
        ),

        /* calls automagically the template init function */
        onReady: function () {
            this.initCommon();
        },

        onLoad: function () {
            this.loadCommon();

        },

        onResize: function () {
            this.WINDOW_HEIGHT = $(window).height();
        },

        initCommon: function () {
            $('body').addClass(this.IS_TOUCH_DEVICE ? 'is-touch' : 'no-touch');
            // init functions
            this.installStickyComponents();
            this.installProductShowcase();
            this.installSpaceUnder();
            this.installCookieBannerListener();
        },

        loadCommon: function () {
            // load functions like Sliders that need pre-renders
            this.installExploreBoxesSlider();
            this.installTextImageSlider();
            this.installAccordion();
            this.installTestimonialsSlider();
            this.installTestimonialsModal();
            this.installKlaviyoFormCharactersCount();
            this.installCalculatorModal();
            this.installCheckoutAddonsSlider();
        },

        installCalculatorModal: function () {
            const calculatorModal = document.querySelector('.calculator__modal');
            if (!calculatorModal) return;

            const $modal = $(calculatorModal);
            const $triggerButton = $('.calculator__trigger-button');
            const $closeButton = $('.calculator__modal-close');

            $triggerButton.on('click', function () {
                $modal.addClass('active');
                $('body').addClass('modal-open');
            });

            $closeButton.on('click', function () {
                $modal.removeClass('active');
                $('body').removeClass('modal-open');
            });
        },

        installCheckoutAddonsSlider: function () {
            window.addonsSliderInitialized = false;
            window.initAddonsSlider = function() {
                window.addonsSliderInitialized = true;
                const productSlider = document.querySelector('.checkout-addons-modal-products-slider .checkout-addons-modal-products-slider-inner');
                if (!productSlider) return;

                $('.checkout-addons-modal-products-slider .checkout-addons-modal-products-slider-inner').each(function () {
                    const $slider = $(this);
                    const $modal = $slider.closest('.checkout-addons-modal');
                    const $arrowLeft = $modal.find('.checkout-addons-modal-slider-arrows .meatzy-button--arrow-left');
                    const $arrowRight = $modal.find('.checkout-addons-modal-slider-arrows .meatzy-button--arrow-right');
                    const $progressBar = $modal.find('.checkout-addons-modal-slider-progress-bar-inner');

                    if ($slider.length) {
                        $slider.slick({
                            slidesToScroll: 1,
                            slidesToShow: 2,
                            infinite: false,
                            arrows: false,
                            swipeToSlide: true,
                            dots: false,
                            centerMode: false,
                            accessibility: false,
                            draggable: true,
                            touchThreshold: 5,
                            edgeFriction: 0.35,
                            responsive: [
                                {
                                    breakpoint: 580,
                                    settings: {
                                        slidesToShow: 1.32,
                                    }
                                },
                                {
                                    breakpoint: 400,
                                    settings: {
                                        slidesToShow: 1.02,
                                    }
                                }
                            ]
                        });

                        // Arrow functionality
                        if ($arrowLeft.length && $arrowRight.length) {
                            $arrowLeft.on('click', function () {
                                $slider.slick('slickPrev');
                            });

                            $arrowRight.on('click', function () {
                                $slider.slick('slickNext');
                            });
                        }

                        // Update progress bar and arrows
                        const updateProgress = function () {
                            const currentSlide = $slider.slick('slickCurrentSlide');
                            const slideCount = $slider.slick('getSlick').slideCount;
                            const slidesToShow = $slider.slick('getSlick').options.slidesToShow;
                            const maxSlide = slideCount - slidesToShow;

                            // Update progress bar
                            let progress = (currentSlide / maxSlide) * 100;
                            if (progress > 100) {
                                progress = 100;
                            }

                            $progressBar.css('width', `${progress}%`);
                            


                            // Update arrow states
                            $arrowLeft.toggleClass('disabled', currentSlide === 0);
                            $arrowRight.toggleClass('disabled', currentSlide >= maxSlide);

                            if(currentSlide === 0 && currentSlide >= maxSlide) {
                                document.querySelector('.checkout-addons-modal-slider-navigation').classList.add('hidden');
                            }
                        };

                        // Update progress bar immediately on slide start
                        const updateProgressOnStart = function (event, slick, currentSlide, nextSlide) {
                            const slideCount = $slider.slick('getSlick').slideCount;
                            const slidesToShow = $slider.slick('getSlick').options.slidesToShow;
                            const maxSlide = slideCount - slidesToShow;

                            // Update progress bar to target position immediately
                            let progress = (nextSlide / maxSlide) * 100;
                            if (progress > 100) {
                                progress = 100;
                            }

                            $progressBar.css('width', `${progress}%`);
                        };

                        // Update on slide change events
                        $slider.on('beforeChange', updateProgressOnStart);
                        $slider.on('afterChange', updateProgress);

                        // Initial state
                        updateProgress();
                    }
                });
            }
        },

        installKlaviyoFormCharactersCount: function () {
            const klaviyoForm = document.querySelector('.contact__form .klaviyo-form');
            if (!klaviyoForm) return;

            const $form = $(klaviyoForm);
            const $formRows = $form.find('[data-testid="form-row"]');

            const $inputToCountFrom = $formRows.find('[id^="Message_"]');

            // Find the rich-text element that comes immediately after the Message input
            const $richText = $inputToCountFrom.closest('[data-testid="form-row"]').next('[data-testid="form-row"]').find('[id^="rich-text-"]');

            if ($richText.length && $inputToCountFrom.length) {
                // Extract current character count from rich text element
                const currentText = $richText.text();
                const match = currentText.match(/(\d+)\s*\/\s*(\d+)/);

                if (match) {
                    const startCount = parseInt(match[1]);
                    const maxLength = parseInt(match[2]);

                    // Set maxlength on the input
                    $inputToCountFrom.attr('maxlength', maxLength);

                    // Update counter on input
                    $inputToCountFrom.on('input', function () {
                        const currentLength = $(this).val().length;
                        const newText = `${startCount + currentLength} / ${maxLength} Characters`;
                        $richText.text(newText);

                        // Optional: Add visual feedback when approaching limit
                        if (currentLength >= maxLength * 0.9) {
                            $richText.addClass('character-limit-warning');
                        } else {
                            $richText.removeClass('character-limit-warning');
                        }
                    });

                    // Initialize counter with starting value
                    const initialText = `${startCount} / ${maxLength} Characters`;
                    $richText.text(initialText);
                }
            }
        },

        installSpaceUnder: function () {
            const mainContent = document.getElementById('MainContent');
            if (!mainContent) return; // stop if #MainContent doesn’t exist

            const firstSection = mainContent.querySelector('.shopify-section.section');
            if (!firstSection) return; // stop if no section found

            const is404 = !!firstSection.querySelector('.template-404');
            const isHero = firstSection.id && firstSection.id.includes('__meatzy_hero');
            const isContactPage = !!firstSection.querySelector('.contact-section');

            if (!isHero && !is404 && !isContactPage) {
                mainContent.classList.add('space-under');
            }
        },

        installExploreBoxesSlider: function () {
            const productSlider = document.querySelector('.explore-boxes__slider .explore-boxes__slider-inner');
            if (!productSlider) return;


            $('.explore-boxes__slider .explore-boxes__slider-inner').each(function () {
                const $slider = $(this);
                const $section = $slider.closest('.meatzy-explore-boxes');
                const $arrowLeft = $section.find('.meatzy-button--arrow-left');
                const $arrowRight = $section.find('.meatzy-button--arrow-right');
                const $progressBar = $section.find('.explore-boxes__slider-progress-bar-inner');

                $slider.closest('.shopify-section').addClass('overflow-hidden');

                if ($slider.length) {
                    $slider.slick({
                        slidesToScroll: 1,
                        slidesToShow: 2.48,
                        infinite: false,
                        arrows: false,
                        swipeToSlide: true,
                        dots: false,
                        centerMode: false,
                        accessibility: false,
                        draggable: true,
                        touchThreshold: 5,
                        edgeFriction: 0.35,
                        responsive: [
                            {
                                breakpoint: 1367,
                                settings: {
                                    slidesToShow: 1.9,
                                }
                            },
                            {
                                breakpoint: 1024,
                                settings: {
                                    slidesToShow: 2.48,
                                }
                            },
                            {
                                breakpoint: 749,
                                settings: {
                                    slidesToShow: 1.9,
                                }
                            },
                            {
                                breakpoint: 580,
                                settings: {
                                    slidesToShow: 1.32,
                                }
                            },
                            {
                                breakpoint: 400,
                                settings: {
                                    slidesToShow: 1.02,
                                }
                            }
                        ]
                    });

                    // Arrow functionality
                    if ($arrowLeft.length && $arrowRight.length) {
                        $arrowLeft.on('click', function () {
                            $slider.slick('slickPrev');
                        });

                        $arrowRight.on('click', function () {
                            $slider.slick('slickNext');
                        });
                    }

                    // Update progress bar and arrows
                    const updateProgress = function () {
                        const currentSlide = $slider.slick('slickCurrentSlide');
                        const slideCount = $slider.slick('getSlick').slideCount;
                        const slidesToShow = $slider.slick('getSlick').options.slidesToShow;
                        const maxSlide = slideCount - slidesToShow;

                        // Update progress bar
                        let progress = (currentSlide / maxSlide) * 100;
                        if (progress > 100) {
                            progress = 100;
                        }

                        $progressBar.css('width', `${progress}%`);

                        // Update arrow states
                        $arrowLeft.toggleClass('disabled', currentSlide === 0);
                        $arrowRight.toggleClass('disabled', currentSlide >= maxSlide);
                    };

                    // Update progress bar immediately on slide start
                    const updateProgressOnStart = function (event, slick, currentSlide, nextSlide) {
                        const slideCount = $slider.slick('getSlick').slideCount;
                        const slidesToShow = $slider.slick('getSlick').options.slidesToShow;
                        const maxSlide = slideCount - slidesToShow;

                        // Update progress bar to target position immediately
                        let progress = (nextSlide / maxSlide) * 100;
                        if (progress > 100) {
                            progress = 100;
                        }

                        $progressBar.css('width', `${progress}%`);
                    };

                    // Update on slide change events
                    $slider.on('beforeChange', updateProgressOnStart);
                    $slider.on('afterChange', updateProgress);

                    // Initial state
                    updateProgress();
                }
            });
        },

        installTextImageSlider: function () {
            const textImageSlider = document.querySelector('.text-image__slider');
            if (!textImageSlider) return;

            $('.text-image__slider').each(function () {
                const $slider = $(this);
                const $section = $slider.closest('.meatzy-text-image');
                const $arrowLeft = $section.find('.text-image__slider-arrow-left');
                const $arrowRight = $section.find('.text-image__slider-arrow-right');
                const $progressBar = $section.find('.text-image__slider-progress-bar-inner');

                $slider.closest('.shopify-section').addClass('overflow-hidden');

                if ($slider.length) {
                    $slider.slick({
                        slidesToScroll: 1,
                        slidesToShow: 3,
                        infinite: false,
                        arrows: false,
                        swipeToSlide: true,
                        dots: false,
                        centerMode: false,
                        accessibility: false,
                        draggable: true,
                        touchThreshold: 5,
                        edgeFriction: 0.35,
                        responsive: [
                            {
                                breakpoint: 1160,
                                settings: {
                                    slidesToShow: 2,
                                }
                            },
                            {
                                breakpoint: 749,
                                settings: {
                                    slidesToShow: 1,
                                }
                            }
                        ]
                    });

                    // Arrow functionality
                    if ($arrowLeft.length && $arrowRight.length) {
                        $arrowLeft.on('click', function () {
                            $slider.slick('slickPrev');
                        });

                        $arrowRight.on('click', function () {
                            $slider.slick('slickNext');
                        });
                    }

                    // Update progress bar and arrows
                    const updateProgress = function () {
                        const currentSlide = $slider.slick('slickCurrentSlide');
                        const slideCount = $slider.slick('getSlick').slideCount;
                        const slidesToShow = $slider.slick('getSlick').options.slidesToShow;
                        const maxSlide = slideCount - slidesToShow;

                        // Update progress bar
                        let progress = (currentSlide / maxSlide) * 100;
                        if (progress > 100) {
                            progress = 100;
                        }

                        $progressBar.css('width', `${progress}%`);

                        // Update active slide counter
                        const $activeCounter = $section.find('.text-image__slider-items-ammount-active');
                        const $totalCounter = $section.find('.text-image__slider-items-ammount-total');

                        // Start with number of visible slides, then add current slide position
                        const activeSlideNumber = (slidesToShow + currentSlide).toString().padStart(2, '0');
                        const totalSlides = slideCount.toString().padStart(2, '0');

                        $activeCounter.text(activeSlideNumber);
                        $totalCounter.text(totalSlides);

                        // Update arrow states
                        $arrowLeft.toggleClass('disabled', currentSlide === 0);
                        $arrowRight.toggleClass('disabled', currentSlide >= maxSlide);
                    };

                    // Update progress bar immediately on slide start
                    const updateProgressOnStart = function (event, slick, currentSlide, nextSlide) {
                        const slideCount = $slider.slick('getSlick').slideCount;
                        const slidesToShow = $slider.slick('getSlick').options.slidesToShow;
                        const maxSlide = slideCount - slidesToShow;

                        // Update progress bar to target position immediately
                        let progress = (nextSlide / maxSlide) * 100;
                        if (progress > 100) {
                            progress = 100;
                        }

                        $progressBar.css('width', `${progress}%`);
                    };

                    // Update on slide change events
                    $slider.on('beforeChange', updateProgressOnStart);
                    $slider.on('afterChange', updateProgress);

                    // Initial state
                    updateProgress();

                    // Hide navigation if slider doesn't need to slide
                    const checkIfSliderNeeded = function () {
                        const slideCount = $slider.slick('getSlick').slideCount;
                        const slidesToShow = $slider.slick('getSlick').options.slidesToShow;

                        // If all slides fit on screen, hide navigation
                        if (slideCount <= slidesToShow) {
                            $section.find('.text-image__slider-navigation').hide();
                        } else {
                            $section.find('.text-image__slider-navigation').show();
                        }
                    };

                    // Check initially and on resize
                    checkIfSliderNeeded();
                    $(window).on('resize', function () {
                        if ($slider.hasClass('slick-initialized')) {
                            checkIfSliderNeeded();
                        }
                    });
                }
            });
        },

        installTestimonialsSlider: function () {
            const testimonialsSlider = document.querySelector('.testimonials__slider');
            if (!testimonialsSlider) return;

            $('.testimonials__slider').each(function () {
                const $slider = $(this);
                const $section = $slider.closest('.meatzy-testimonials');
                const $arrowLeft = $section.find('.testimonials__slider-arrow-left');
                const $arrowRight = $section.find('.testimonials__slider-arrow-right');
                const $progressBar = $section.find('.testimonials__slider-progress-bar-inner');

                if ($slider.length) {
                    $slider.slick({
                        slidesToScroll: 1,
                        slidesToShow: 3,
                        infinite: false,
                        arrows: false,
                        swipeToSlide: true,
                        dots: false,
                        centerMode: false,
                        accessibility: false,
                        draggable: true,
                        touchThreshold: 5,
                        edgeFriction: 0.35,
                        responsive: [
                            {
                                breakpoint: 1024,
                                settings: {
                                    slidesToShow: 2,
                                }
                            },
                            {
                                breakpoint: 749,
                                settings: {
                                    slidesToShow: 1,
                                }
                            }
                        ]
                    });

                    // Arrow functionality
                    if ($arrowLeft.length && $arrowRight.length) {
                        $arrowLeft.on('click', function () {
                            $slider.slick('slickPrev');
                        });

                        $arrowRight.on('click', function () {
                            $slider.slick('slickNext');
                        });
                    }

                    // Update progress bar and arrows
                    const updateProgress = function () {
                        const currentSlide = $slider.slick('slickCurrentSlide');
                        const slideCount = $slider.slick('getSlick').slideCount;
                        const slidesToShow = $slider.slick('getSlick').options.slidesToShow;
                        const maxSlide = slideCount - slidesToShow;

                        // Update progress bar
                        let progress = (currentSlide / maxSlide) * 100;
                        if (progress > 100) {
                            progress = 100;
                        }

                        $progressBar.css('width', `${progress}%`);

                        // Update active slide counter
                        const $activeCounter = $section.find('.testimonials__slider-items-ammount-active');
                        const $totalCounter = $section.find('.testimonials__slider-items-ammount-total');

                        // Start with number of visible slides, then add current slide position
                        const activeSlideNumber = (slidesToShow + currentSlide).toString().padStart(2, '0');
                        const totalSlides = slideCount.toString().padStart(2, '0');
                        $activeCounter.text(activeSlideNumber);
                        $totalCounter.text(totalSlides);

                        // Update arrow states
                        $arrowLeft.toggleClass('disabled', currentSlide === 0);
                        $arrowRight.toggleClass('disabled', currentSlide >= maxSlide);
                    };

                    // Update progress bar immediately on slide start
                    const updateProgressOnStart = function (event, slick, currentSlide, nextSlide) {
                        const slideCount = $slider.slick('getSlick').slideCount;
                        const slidesToShow = $slider.slick('getSlick').options.slidesToShow;
                        const maxSlide = slideCount - slidesToShow;

                        // Update progress bar to target position immediately
                        let progress = (nextSlide / maxSlide) * 100;
                        if (progress > 100) {
                            progress = 100;
                        }

                        $progressBar.css('width', `${progress}%`);
                    };

                    // Update on slide change events
                    $slider.on('beforeChange', updateProgressOnStart);
                    $slider.on('afterChange', updateProgress);

                    // Initial state
                    updateProgress();

                    // Hide navigation if slider doesn't need to slide
                    const checkIfSliderNeeded = function () {
                        const slideCount = $slider.slick('getSlick').slideCount;
                        const slidesToShow = $slider.slick('getSlick').options.slidesToShow;

                        // If all slides fit on screen, hide navigation
                        if (slideCount <= slidesToShow) {
                            $section.find('.testimonials__slider-navigation').hide();
                        } else {
                            $section.find('.testimonials__slider-navigation').show();
                        }
                    };

                    // Check initially and on resize
                    checkIfSliderNeeded();
                    $(window).on('resize', function () {
                        if ($slider.hasClass('slick-initialized')) {
                            checkIfSliderNeeded();
                        }
                    });
                }
            });
        },

        installTestimonialsModal: function () {
            const modal = document.getElementById('testimonialsModal');
            if (!modal) return;

            const $modal = $(modal);
            const $overlay = $modal.find('.testimonials__modal-overlay');
            const $closeBtn = $modal.find('.testimonials__modal-close');
            const $prevBtn = $modal.find('.testimonials__modal-prev');
            const $nextBtn = $modal.find('.testimonials__modal-next');
            const $currentSpan = $modal.find('.testimonials__modal-current');
            const $totalSpan = $modal.find('.testimonials__modal-total');
            const $testimonialContent = $modal.find('.testimonials__modal-testimonial');
            const $authorImage = $modal.find('.testimonials__modal-author-image');
            const $authorName = $modal.find('.testimonials__modal-author-name');
            const $authorRole = $modal.find('.testimonials__modal-author-role');

            let currentIndex = 0;
            let testimonialsData = [];

            // Collect testimonials data from the page
            $('.testimonials__slider-item').each(function () {
                const $item = $(this);
                const $author = $item.find('.testimonials__slider-author');

                // Get the full testimonial content from the data attributes
                const testimonialIndex = $item.find('.testimonials__modal-trigger').data('testimonial-index');
                const fullTestimonial = $item.data('testimonial-full');

                testimonialsData.push({
                    testimonial: fullTestimonial || '',
                    authorImage: $author.find('img').attr('src') || '',
                    authorName: $author.find('.testimonials__slider-author-name').text(),
                    authorRole: $author.find('.testimonials__slider-author-role').html(),
                    index: testimonialIndex
                });
            });

            // Update modal content
            function updateModalContent(index) {
                if (testimonialsData[index]) {
                    const testimonial = testimonialsData[index];

                    $testimonialContent.html(testimonial.testimonial);
                    $authorName.text(testimonial.authorName);
                    $authorRole.html(testimonial.authorRole);

                    if (testimonial.authorImage) {
                        $authorImage.html(`<img src="${testimonial.authorImage}" alt="${testimonial.authorName}" width="80" height="80" loading="lazy">`);
                    } else {
                        $authorImage.html('<div style="width: 80px; height: 80px; background: #ddd; border-radius: 50%; display: flex; align-items: center; justify-content: center; color: #999;">No Image</div>');
                    }

                    // Update counter
                    $currentSpan.text((index + 1).toString().padStart(2, '0'));
                    $totalSpan.text(testimonialsData.length.toString().padStart(2, '0'));

                    // Update navigation buttons
                    $prevBtn.prop('disabled', index === 0);
                    $nextBtn.prop('disabled', index === testimonialsData.length - 1);
                }
            }

            // Open modal
            function openModal(index) {
                currentIndex = index;
                updateModalContent(currentIndex);
                $modal.addClass('active');
                $('body').addClass('modal-open');
            }

            // Close modal
            function closeModal() {
                $modal.removeClass('active');
                $('body').removeClass('modal-open');
            }

            // Event listeners
            $('.testimonials__modal-trigger').on('click', function () {
                const index = parseInt($(this).data('testimonial-index'));
                openModal(index);
            });

            $closeBtn.on('click', closeModal);
            $overlay.on('click', closeModal);

            $prevBtn.on('click', function () {
                if (currentIndex > 0) {
                    currentIndex--;
                    updateModalContent(currentIndex);
                }
            });

            $nextBtn.on('click', function () {
                if (currentIndex < testimonialsData.length - 1) {
                    currentIndex++;
                    updateModalContent(currentIndex);
                }
            });

            // Keyboard navigation
            $(document).on('keydown', function (e) {
                if ($modal.hasClass('active')) {
                    if (e.key === 'Escape') {
                        closeModal();
                    } else if (e.key === 'ArrowLeft' && currentIndex > 0) {
                        currentIndex--;
                        updateModalContent(currentIndex);
                    } else if (e.key === 'ArrowRight' && currentIndex < testimonialsData.length - 1) {
                        currentIndex++;
                        updateModalContent(currentIndex);
                    }
                }
            });
        },

        installAccordion: function () {
            $('.faq-item').on('click', function () {
                const $item = $(this);
                const $answer = $item.find('.faq-answer');
                const $accordion = $item.closest('.faq__accordion');
                const preventClose = $accordion.data('prevent-close');

                // If prevent_close is enabled and item is already active, don't close it
                if (preventClose && $item.hasClass('active')) {
                    return;
                }

                // If prevent_close is enabled, only allow opening (not closing)
                if (preventClose) {
                    $item.addClass('active');
                } else {
                    // Normal toggle behavior
                    $item.toggleClass('active');
                }

                // Close other open items (optional - remove if you want multiple open)
                $('.faq-item').not($item).removeClass('active');
            });
        },

        installStickyComponents: function () {
            // Find all components that should be sticky
            const components = document.querySelectorAll('.meatzy-section--sticky');
            components.forEach(component => {
                const wrapper = this.findShopifySectionWrapper(component);
                if (wrapper) {
                    wrapper.classList.add('sticky');
                }
            });
        },

        findShopifySectionWrapper: function (element) {
            // Try to find the Shopify section wrapper
            return element.closest('.shopify-section') ||
                element.closest('[id^="shopify-section-"]') ||
                element.parentElement;
        },

        installProductShowcase: function () {
            console.log('product-showcase-installed');
            const productShowcases = document.querySelectorAll('[data-showcase]');

            productShowcases.forEach(showcase => {
                const showcaseItems = showcase.querySelectorAll('[data-showcase-item]');

                // Start with all showcase items closed (no active by default)
                showcaseItems.forEach(item => {
                    item.classList.remove('active');
                });

                // Format prices with superscript decimals
                this.formatPricesWithSuperscript(showcase);

                // Listen for hash changes in the URL
                const handleHashChange = () => {
                    const hash = window.location.hash.substring(1); // Remove the # symbol

                    if (hash) {
                        // Remove active class from all items
                        showcaseItems.forEach(item => {
                            item.classList.remove('active');
                        });

                        // Find and activate the item that matches the hash
                        const targetItem = showcase.querySelector(`[data-showcase-item="${hash}"]`);
                        if (targetItem) {
                            targetItem.classList.add('active');
                        }
                    }
                };

                // Listen for hash changes
                window.addEventListener('hashchange', handleHashChange);

                // Check initial hash on load
                handleHashChange();

                // Handle desktop mega menu product links - these should prevent default and toggle showcase
                const megaMenuProductLinks = document.querySelectorAll('[data-mega-menu-product-link="true"]');
                console.log('Found mega menu product links:', megaMenuProductLinks.length);

                megaMenuProductLinks.forEach(link => {
                    link.addEventListener('click', function (e) {
                        console.log('Mega menu product link clicked:', this.href);
                        e.preventDefault(); // Prevent default link behavior

                        const href = this.getAttribute('href');
                        if (href && href.includes('#')) {
                            const hash = href.split('#')[1]; // Get hash from URL
                            console.log('Extracted hash:', hash);
                            console.log('Available showcase items:', showcaseItems.length);

                            // Log all available showcase items
                            showcaseItems.forEach(item => {
                                console.log('Showcase item:', item.getAttribute('data-showcase-item'));
                            });

                            // Remove active class from all items
                            showcaseItems.forEach(item => {
                                item.classList.remove('active');
                            });

                            // Find and activate the item that matches the hash
                            const targetItem = showcase.querySelector(`[data-showcase-item="${hash}"]`);
                            console.log('Target item found:', targetItem);
                            if (targetItem) {
                                targetItem.classList.add('active');
                                console.log('Activated showcase item:', hash);
                            } else {
                                console.log('No showcase item found for hash:', hash);
                            }
                        }
                    });
                });

                // Handle product links in mega menu - these should prevent default and toggle showcase
                // Only target links in the menu list, not buttons inside product cards
                const productLinks = document.querySelectorAll('.mega-menu__list a[href*="/products/"]');
                console.log('Found product links in mega menu:', productLinks.length);

                productLinks.forEach(link => {
                    console.log('Setting up listener for product link:', link.href);
                    link.addEventListener('mouseover', function (e) {
                        console.log('Product link clicked:', this.href);

                        // Extract product handle from URL
                        const href = this.getAttribute('href');
                        const productHandle = href.split('/products/')[1];
                        console.log('Product handle:', productHandle);

                        // Find and activate the item that matches the product handle
                        const targetItem = showcase.querySelector(`[data-showcase-item="${productHandle}"]`);
                        console.log('Target item found:', targetItem);

                        if (targetItem) {
                            // Only prevent default if we found a matching showcase item
                            e.preventDefault();
                            console.log('Prevented default navigation - found matching showcase item');

                            // Remove active class from all showcase items and links
                            showcaseItems.forEach(item => {
                                item.classList.remove('active');
                            });

                            // Remove active class from all product links in this mega menu
                            const allProductLinks = showcase.closest('.mega-menu__content').querySelectorAll('a[href*="/products/"]');
                            allProductLinks.forEach(link => {
                                link.classList.remove('mega-menu__link--active');
                            });

                            // Activate the matching showcase item
                            targetItem.classList.add('active');

                            // Add active class to the clicked link
                            this.classList.add('mega-menu__link--active');

                            console.log('Activated showcase item:', productHandle);
                            console.log('Added active class to link:', this.href);
                        } else {
                            console.log('No showcase item found for product:', productHandle, '- allowing normal navigation');
                            // Don't prevent default - let the link navigate normally
                        }
                    });
                });


                // Handle regular hash links (for non-mega-menu contexts)
                const regularHashLinks = document.querySelectorAll('a[href^="#"]:not([data-mega-menu-product-link])');
                regularHashLinks.forEach(link => {
                    link.addEventListener('click', function (e) {
                        const href = this.getAttribute('href');
                        if (href && href.startsWith('#')) {
                            const hash = href.substring(1);

                            // Remove active class from all items
                            showcaseItems.forEach(item => {
                                item.classList.remove('active');
                            });

                            // Find and activate the item that matches the hash
                            const targetItem = showcase.querySelector(`[data-showcase-item="${hash}"]`);
                            if (targetItem) {
                                targetItem.classList.add('active');
                            }
                        }
                    });
                });
            });
        },

        formatPricesWithSuperscript: function (container) {
            // Ensure container is valid, default to document
            const searchContainer = container && container.querySelectorAll ? container : document;

            // Format prices in the specified container
            const containerPriceItems = searchContainer.querySelectorAll('.card-wrapper .price-item');
            this.formatPriceItems(containerPriceItems);

            // If container is not document, also format all prices on the page
            if (searchContainer !== document) {
                const allPriceItems = document.querySelectorAll('.card-wrapper .price-item');
                this.formatPriceItems(allPriceItems);
            }
        },

        formatPriceItems: function (priceItems) {
            // Ensure priceItems is valid and iterable
            if (!priceItems || !priceItems.forEach) {
                console.warn('formatPriceItems: Invalid priceItems parameter');
                return;
            }

            priceItems.forEach(priceItem => {
                try {
                    // Skip if already formatted or if element is invalid
                    if (!priceItem || !priceItem.querySelector || !priceItem.textContent) {
                        return;
                    }

                    if (priceItem.querySelector('.price-superscript')) {
                        return;
                    }

                    const originalText = priceItem.textContent.trim();

                    // Match price format like "$259.00 USD" or "259.00"
                    const priceMatch = originalText.match(/(\$?)(\d+)\.(\d+)(\s*USD)?/);

                    if (priceMatch) {
                        const currency = priceMatch[1] || '';
                        const wholeNumber = priceMatch[2];
                        const decimal = priceMatch[3];
                        const suffix = priceMatch[4] || '';

                        // Create new HTML with superscript decimal
                        priceItem.innerHTML = `${currency}${wholeNumber}<span class="price-superscript">.${decimal}</span>${suffix}`;
                    }
                } catch (error) {
                    console.warn('Error formatting price item:', error);
                }
            });
        },

        installCookieBannerListener: function () {
            const links = document.querySelectorAll('a[href="#open-cookie-preferences"]');
            if (!links.length) return;

            links.forEach(link => {
                link.addEventListener('click', (e) => {
                    e.preventDefault();

                    // --- Shopify CMP (built-in banner) ---
                    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
                        privacyBanner.showPreferences().catch(err =>
                            console.warn('privacyBanner.showPreferences() error:', err)
                        );
                        return;
                    }

                    // --- Customer Privacy API fallback ---
                    if (window.Shopify && window.Shopify.customerPrivacy) {
                        if (typeof window.Shopify.customerPrivacy.showPreferences === 'function') {
                            window.Shopify.customerPrivacy.showPreferences();
                            return;
                        }
                    }

                    console.warn('No Shopify CMP detected — make sure the privacy banner script is loaded.');
                });
            });
        }
    };


    /* Init awesome stuff */
    $(function () {
        APP.onReady();
    });
    $(window).resize(function () {
        APP.onResize();
    });
    $(window).on('load', function () {
        APP.onLoad();
    });

})(jQuery);
